import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EnglishArabicDTO, FilterItem, FilterType, InputType, MultiLingualTextBoxOptions, PagingOptions, TextBoxOptions, FormOptions, ConfirmationModalOptions, PagingActionMode, StyleConfirmationMode } from 'bnsights-control-library';
import { DepartmentService } from '../../shared/Services/DepartmentService.service';
import { DepartmentModel } from '../../shared/models/DepartmentModels/DepartmentModel';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { NgbModal,  } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, EnvironmentService, UtilityService, BBSFTranslateService } from 'bnsights-utilities-library';
import { Observable } from 'rxjs';
import { PagingComponent } from 'bnsights-control-library/lib/controls/Paging/Paging.component';
import { ConfirmationModalComponent } from 'bnsights-control-library/lib/controls/ConfirmationModal/ConfirmationModal.component';
@Component({
  selector: 'lib-department',
  templateUrl: './department.component.html',
})
export class DepartmentComponent implements OnInit {
  //Page requirements
  ShowPageContent: boolean = false;
  ProductionMode: boolean;
  language: string = ""
  ApiUrl = "/api/admin/Department/"

  //Filter and paging components
  DepartmentForm = new FormGroup({});
  searchTextBox: TextBoxOptions;
  TextInputFilter: FilterItem;
  IsFilterLoaded: boolean = false;
  DepartmentPaging: PagingOptions;
  DepartmentPagingResult: any[] = [];
  @ViewChild('DepartmentPagingViewElement', { static: false }) pagingElement: PagingComponent;

  //Add Model Controls
  AddDepartmentForm = new FormGroup({});
  AddDepartmentFormOptions: FormOptions
  AddName:MultiLingualTextBoxOptions
  AddSamAccount: TextBoxOptions;
  @ViewChild('CloseDepartmentModal', { static: false }) CloseDepartmentModal: ElementRef;

  //Edit Model Controls
  EditDepartmentForm = new FormGroup({});
  EditDepartmentFormOptions: FormOptions
  EditName:MultiLingualTextBoxOptions
  EditSamAccount: TextBoxOptions;
  DepartmentId: number;
  @ViewChild('CloseEditDepartmentModal', { static: false }) CloseEditDepartmentModal: ElementRef;

  //delete  Model Controls
  deleteDepartmentId: string;
  DeleteConfirmationOptions: ConfirmationModalOptions;
  deleteControlLoaded: boolean = false;
  @ViewChild('ConfirmationModalControl', { static: false }) ConfirmationModalControl: ConfirmationModalComponent;



  constructor
  (
    private environmentService:EnvironmentService,
    private DepartmentService: DepartmentService,
    private modalService: NgbModal,
    private authService: AuthService,
    private BBSFTranslateService: BBSFTranslateService,
    public UtilityService: UtilityService,
    private pageInfoService:PageInfoService
   ) 
  {
  }

   async ngOnInit() {
     this.ShowPageContent = true;
     //Page header (breadcrumb and title)
     PageInfoService.PageTitle = this.UtilityService.getResourceValue("Departments")
     PageInfoService.PageBreadcrumbs = [
       { title: this.UtilityService.getResourceValue("Home"), path: '/Admin/Home', isSeparator: false, isActive: false },
       { title: '', path: '', isSeparator: true, isActive: false }

     ];
     this.pageInfoService.calculateTitle();
     this.pageInfoService.calculateBreadcrumbs();
     this.language = await this.UtilityService.getCurrentLanguage();
     this.ProductionMode = this.environmentService.getProductionMode();

     //initialize page
     this.initializePage();


  }


  //Initialize filters and paging
  initializePage() {
      // TextBox inti
      this.searchTextBox = new TextBoxOptions();
      this.searchTextBox.Name = "searchTextBox"
      this.searchTextBox.HideLabel = true;
      this.searchTextBox.Type = InputType.Text
      this.searchTextBox.Placeholder = this.UtilityService.getResourceValue("SearchByName")

      this.TextInputFilter = new FilterItem();
      this.TextInputFilter.FormControlName = "searchTextBox"
      this.TextInputFilter.ActionParameterName = "searchText"
      this.TextInputFilter.IsFormControl = true
      this.TextInputFilter.FilterType = FilterType.TextBox

      this.DepartmentPaging = new PagingOptions();
      this.DepartmentPaging.ActionPostURL =  this.ApiUrl + 'GetDepartmentsByFilter';
      this.DepartmentPaging.OnKeyPressFiltersControlNames = ["searchTextBox"]
      this.DepartmentPaging.Filters = [this.TextInputFilter]
      this.DepartmentPaging.ValidationToken = this.authService.authorizationHeaderValue()
      this.IsFilterLoaded = true;
      
  }

  //Paging functions
  setDepartmentListResult(result) {
    this.DepartmentPagingResult= result
    this.ShowPageContent=true;
    this.UtilityService.stopBlockUI()
  }


  //Add department
  showAddDepartmentModal(addDepartmentModal) {
    this.UtilityService.startBlockUI()
    this.AddDepartmentForm = new FormGroup({})

    this.AddDepartmentFormOptions = new FormOptions();
    this.AddDepartmentFormOptions.FormGroup = this.AddDepartmentForm
    this.AddDepartmentFormOptions.GetModelFunction = this.getAddDepartmentModel;
    this.AddDepartmentFormOptions.ServiceSubmitFunction = this.getAddDepartmentFunction;
    this.AddDepartmentFormOptions.PagingReference = this.pagingElement  

    this.AddName = new MultiLingualTextBoxOptions();
    this.AddName.Name = "AddName";
    this.AddName.ArabicLabelKey = "NameInArabic";
    this.AddName.EnglishLabelKey = "NameInEnglish";
    this.AddName.IsRequired = true;
    this.AddName.Value = null;
    
    this.AddSamAccount = new TextBoxOptions();
    this.AddSamAccount.Name = "AddSamAccount";
    this.AddSamAccount.LabelKey = "SamAccount";
    this.AddSamAccount.Type = InputType.Text;
    this.AddSamAccount.Value = null;

    this.modalService.open(addDepartmentModal);
    this.UtilityService.stopBlockUI();
  }

  getAddDepartmentModel = () => {
    let paramArray: any[] = [];
    let ResultModel = this.AddDepartmentForm.value;
    let AddModel: DepartmentModel = new DepartmentModel();
    AddModel.SamAccount = ResultModel.AddSamAccount;
    AddModel.DepartmentNameDTO.Arabic = ResultModel.AddName.ArabicValue;
    AddModel.DepartmentNameDTO.English = ResultModel.AddName.EnglishValue;
    paramArray.push(AddModel);
    return paramArray;
  }

  getAddDepartmentFunction = (AddModel): Observable<any> => {
    return this.DepartmentService.addDepartment(AddModel)
  }

  //Edit department
  showEditDepartmentModal(departmentId: number,departmentIDEnc: string, editDepartmentModal) {
    this.EditDepartmentForm = new FormGroup({});

    this.EditDepartmentFormOptions = new FormOptions();
    this.EditDepartmentFormOptions.FormGroup = this.EditDepartmentForm
    this.EditDepartmentFormOptions.GetModelFunction = this.getEditDepartmentModel;
    this.EditDepartmentFormOptions.ServiceSubmitFunction = this.getEditDepartmentFunction;
    this.EditDepartmentFormOptions.PagingReference = this.pagingElement

    this.DepartmentId = departmentId;
    this.DepartmentService.getEditDepartment(departmentIDEnc).subscribe((result: any) => {
      let department = result.model as any;

      let name = new EnglishArabicDTO();
      name.Arabic = department.departmentNameDTO.arabic;
      name.English = department.departmentNameDTO.english;

      this.EditName = new MultiLingualTextBoxOptions();
      this.EditName.Name = "EditName";
      this.EditName.ArabicLabelKey = "NameInArabic";
      this.EditName.EnglishLabelKey = "NameInEnglish";
      this.EditName.IsRequired = true;
      this.EditName.Value = name;


      this.EditSamAccount = new TextBoxOptions();
      this.EditSamAccount.Name = "EditSamAccount";
      this.EditSamAccount.LabelKey = "SamAccount";
      this.EditSamAccount.Type = InputType.Text;
      this.EditSamAccount.Value = department.samAccount;

      this.modalService.open(editDepartmentModal);

    });

  }

  getEditDepartmentModel = () => {
    let paramArray: any[] = [];
    let ResultModel = this.EditDepartmentForm.value;
    let EditModel: DepartmentModel = new DepartmentModel();
    EditModel.Id = this.DepartmentId;
    EditModel.DepartmentNameDTO.English = ResultModel.EditName.EnglishValue;
    EditModel.DepartmentNameDTO.Arabic = ResultModel.EditName.ArabicValue;
    EditModel.SamAccount = ResultModel.EditSamAccount;
    paramArray.push(EditModel);
    return paramArray;
  }

  getEditDepartmentFunction = (EditModel): Observable<any> => {
    return this.DepartmentService.editDepartment(EditModel)
  }

  //Delete department
  showDeleteDepartmentModal(departmentIdEnc: any) {
    this.deleteDepartmentId = departmentIdEnc;

    //array sent to service function
    let paramArray: any[] = [];
    paramArray.push(this.deleteDepartmentId);

    this.DeleteConfirmationOptions = new ConfirmationModalOptions();
    this.DeleteConfirmationOptions.ServiceSubmitFunction = this.deleteDepartment;
    this.DeleteConfirmationOptions.ServiceSubmitModel = paramArray;
    this.DeleteConfirmationOptions.PagingReference = this.pagingElement;

    this.deleteControlLoaded = true;
    //setTimeout(() => {
    //  this.ConfirmationModalControl.showModal();
    //}, 300);
  }

  deleteDepartment = (id:string): Observable<any> => {
    return this.DepartmentService.deleteDepartment(id);
  }


}
